module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dc4e4c467dbe22fe4267d60d3934dde8.png";